import axios from 'axios'
import { sha256 } from 'js-sha256';
import base64url from "base64url";
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {
    user_account_balance_info_data: [],
    pdf_error: false,
    pdf_archive_error: false,
  },
  mutations: {
    userAccountBalanceInfoAction: (state, response) => state.user_account_balance_info_data = response,
    errorPdfAction: (state, response) => state.pdf_error = response,
    errorPdfArchiveAction: (state, response) => state.pdf_archive_error = response,
  },
  actions: {
    async userAccountBalanceInfo(ctx, dates){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item = window.location.pathname.split('/').pop()
      const data1 = dates.date1.replace(new RegExp('-','g'),'.').split('.').reverse().join(".");
      const data2 = dates.date2.replace(new RegExp('-','g'),'.').split('.').reverse().join(".");
      await axios.get(
        `${API_URL}/api/rest/receipt/payments_info?lico=${item}&secret_key=${key}&data_s=${data1}&data_po=${data2}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((/*response*/) => {
        localStorage.setItem('weltumTimeAuth', Date.now())
      })
    },
    async userAccountBalanceInfoBills(ctx, dates){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const item = window.location.pathname.split('/').pop()
      const data1 = dates.date1.replace(new RegExp('-','g'),'.').split('.').reverse().join("").substr(2);
      const data2 = dates.date2.replace(new RegExp('-','g'),'.').split('.').reverse().join("").substr(2);
      await axios.get(
        `${API_URL}/api/rest/receipt/balance_hystory_info?lico=${item}&secret_key=${key}&data_s=${data1}&data_po=${data2}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const userData = response.data.items
        ctx.commit('userAccountBalanceInfoAction', userData)
      })
    },

    async userBillPrintPdf(ctx){
      const KEY = localStorage.getItem("weltumKey")
      const TIME = Date.now().toString()
      const DATA_STRING = sha256.hmac(KEY, TIME);
      const HMAC = base64url(DATA_STRING)
      const USER_SCHET = window.location.pathname.split('/').pop()
      const MONTH_DATA = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
      const MONTH = MONTH_DATA[new Date().getMonth()]
      let year = new Date().getUTCFullYear() 
      if(MONTH === '12'){ year = year - 1}
      const DATE = String(MONTH)  + String(year) 
      await axios.get(
        `${API_URL}/api/rest/receipt/get_schet?lico=${USER_SCHET}&data_s=${DATE}&secret_key=${KEY}`, 
        {
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'X-Hmac': HMAC,
            'X-Time': TIME, 
          },
          responseType: 'arraybuffer',
        },
      ).then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' }),
        url = window.URL.createObjectURL(blob)
        window.open(url)
      }).catch((error) => {
        if(error.message === 'Request failed with status code 404'){
          ctx.commit('errorPdfAction', true)
        }
      });
    },
    async userArchivePrintPdf(ctx, dates){
      let lang = 'uk'
      if(this.locale === 'ru_RU'){
        lang = 'ru'
      }
      let data_s = ""
      let data_po = ""
      if(typeof dates[0] == "object"){
        data_s = ("0" + dates[0]._i.split('/')[1]).slice(-2) + dates[0]._i.split('/')[0]
      }else {
        data_s = dates[0].split('-')
        data_s = data_s[1] + data_s[0]
      }
      if(typeof dates[1] == "object"){
        data_po = ("0" + dates[1]._i.split('/')[1]).slice(-2) + dates[1]._i.split('/')[0]
      }else {
        data_po = dates[1].split('-')
        data_po = data_po[1] + data_po[0]
      }
      const KEY = localStorage.getItem("weltumKey")
      const TIME = Date.now().toString()
      const DATA_STRING = sha256.hmac(KEY, TIME);
      const HMAC = base64url(DATA_STRING)
      const USER_SCHET = window.location.pathname.split('/').pop()
      await axios.get(
          `${API_URL}/api/rest/receipt/get_otchet?lico=${USER_SCHET}&data_s=${data_s}&data_po=${data_po}&lang=${lang}&secret_key=${KEY}`,
          {
            headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/pdf',
              'X-Hmac': HMAC,
              'X-Time': TIME,
            },
            responseType: 'arraybuffer',
          },
      ).then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' }),
            url = window.URL.createObjectURL(blob)
        window.open(url)
      }).catch((error) => {
        if(error.message === 'Request failed with status code 404'){
          ctx.commit('errorPdfArchiveAction', true)
        }
      });
    },

    async userInquiryPdf(/*ctx*/){
      const KEY = localStorage.getItem("weltumKey")
      const TIME = Date.now().toString()
      const DATA_STRING = sha256.hmac(KEY, TIME);
      const HMAC = base64url(DATA_STRING)
      const USER_SCHET = window.location.pathname.split('/').pop()
      await axios.get(
        `${API_URL}/api/rest/receipt/get_dovidka?lico=${USER_SCHET}&secret_key=${KEY}`,
        {
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'X-Hmac': HMAC,
            'X-Time': TIME,
          },
          responseType: 'arraybuffer',
        },
      ).then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' }),
          url = window.URL.createObjectURL(blob)
        window.open(url)
      })

    },

    async tarifArchivePdf(/*ctx*/){
      const KEY = localStorage.getItem("weltumKey")
      const TIME = Date.now().toString()
      const DATA_STRING = sha256.hmac(KEY, TIME);
      const HMAC = base64url(DATA_STRING)
      await axios.get(
        `${API_URL}/api/rest/receipt/get_arhiv_tarifs?secret_key=${KEY}`,
        {
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'X-Hmac': HMAC,
            'X-Time': TIME,
          },
          responseType: 'arraybuffer',
        },
      ).then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' }),
          url = window.URL.createObjectURL(blob)
        window.open(url)
      })
    },
  },
  getters:{
    userAccountBalanceInfoData: s => s.user_account_balance_info_data,
    pdf_error: s => s.pdf_error,
  },
}